import { render, staticRenderFns } from "./lesion.vue?vue&type=template&id=e9bbdbf0&"
import script from "./lesion.vue?vue&type=script&lang=js&"
export * from "./lesion.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports